import { bootstrapper } from "@common/bootstrapper/bootstrapper";
import { COMPONENT_TYPES } from "@common/bootstrapper/component-types";
import "./main.scss";
import "../node_modules/bootstrap/js/dist/dropdown";
import "../node_modules/bootstrap/js/dist/offcanvas";
import "../node_modules/bootstrap/js/dist/collapse";
bootstrapper(COMPONENT_TYPES);
